<template>
	<div class="i-surveys-form">
		<!-- OCR识别按钮 - 固定在右上角 -->
		<div class="ocr-button-fixed" v-if="detail.openOcr">
			<van-button
				type="primary"
				size="small"
				icon="scan"
				@click="showOcrPopup = true"
			>
				AI-OCR识别
			</van-button>
		</div>

		<div class="work_time" v-if="detail.reviewStatus == 4">
			<div>提交时间：{{ workTime.submitTime }}</div>
			<div>完成时间：{{ workTime.doneTime }}</div>
		</div>
		<div
			class="i-surveys-form-message"
			v-if="detail.reviewStatus == 3 && detail.reviewComment"
		>
			<van-notice-bar
				color="#FA5151"
				background="#FDEAEA"
				left-icon="info"
				wrapable
				:scrollable="false"
				:text="`驳回原因：${detail.reviewComment}`"
			/>
			<div class="is_show_fail_topic">
				<van-checkbox
					v-model="isShowFailTopic"
					icon-size="16px"
					checked-color="var(--color-primary)"
					>仅展示被驳回题目</van-checkbox
				>
			</div>
		</div>
		<div class="i-surveys-form-main">
			<van-form ref="vanForm" @submit="clickSubmit" scroll-to-error>
				<!-- 如果是副表单 需要增加一个关联题 -->
				<div
					class="i-surveys-form-input"
					v-if="detail.mainDeputyType == 3"
				>
					<form-item
						:mustAnswer="1"
						:label="detail.relatedQuestionTypeName"
						:toastText="detail.relatedQuestionTypeDesc"
					>
						<van-field
							v-model="detail.mainAnswerValue"
							placeholder="请选择"
							:rules="[{ required: true, message: '请选择' }]"
							:readonly="true"
							@click-input="showPicker"
						/>
					</form-item>
				</div>
				<div v-for="(item, index) in exam" :key="item.locationKey">
					<component
						:ref="`topic_${item.locationKey}`"
						:is="getComponentName(item.questionType)"
						v-model="item.value"
						:getComponentName="getComponentName"
						:getComponentAttr="getComponentAttr"
						v-bind="getComponentAttr(item, index)"
						v-if="checkShowMethods(item, index, true)"
						:itemIndex="index"
						:checkShowMethods="checkShowMethods"
						:mustAnswer="item.mustAnswer"
						:questionType="item.questionType"
						@scrollExam="handleScrollExam"
						@updateOptions="updateOptions"
						:needCount="item.needCount"
						@sumBlur="handlerSumBlur"
						@calculateFormula="handleCalculateFormula"
					>
					</component>
				</div>
				<div class="placeholder"></div>
				<base-footer
					v-if="$route.query.formType !== 'preview'"
					background-color="#fff"
				>
					<van-row :gutter="20">
						<van-col :span="12">
							<van-button
								block
								round
								native-type="button"
								@click="clickTemporaryStorage"
								>暂 存</van-button
							>
						</van-col>
						<van-col :span="12">
							<van-button
								type="primary"
								block
								round
								native-type="submit"
								>提 交</van-button
							>
						</van-col>
					</van-row>
				</base-footer>
			</van-form>
		</div>
		<van-popup v-model="showCodePopup" position="bottom">
			<van-picker
				title="标题"
				show-toolbar
				:columns="linkList"
				@confirm="linkConfirm"
				@cancel="linkCancel"
			/>
		</van-popup>

		<!-- OCR识别弹窗 -->
		<form-ocr-popup
			v-model="showOcrPopup"
			:ocr-keywords="allOcrKeywords"
			@close="showOcrPopup = false"
			@ocr-success="handleOcrSuccess"
		/>
		<AiLukVideo :detail="detail" />
	</div>
</template>

<script>
import FormItem from "./components/form-item.vue";
import FormInput from "./components/form-input.vue";
import FormTextarea from "./components/form-textarea.vue";
import FormRadio from "./components/form-radio.vue";
import FormCheckbox from "./components/form-checkbox.vue";
import FormUpload from "./components/form-upload.vue";
import FormDate from "./components/form-date.vue";
import FormTitle from "./components/form-title.vue";
import FormSubTitle from "./components/form-sub-title.vue";
import FormBmi from "./components/form-bmi.vue";
import FormSum from "./components/form-sum.vue";
import FormSbm from "./components/form-sbm.vue";
import FormMsqV2 from "./components/form-msq-v2.vue";
import DmActivityMixin from "@/mixins/dm-activity";
import FormPathSelect from "./components/form-path-select.vue";
import FormOcrPopup from "./components/form-ocr-popup.vue";
import { mapMutations } from "vuex";
import AiLukVideo from "./components/ai-luk-video.vue";
import { Dialog } from "vant";
export default {
	name: "surveysForm",
	mixins: [DmActivityMixin],
	components: {
		AiLukVideo,
		FormItem,
		FormInput,
		FormTextarea,
		FormRadio,
		FormCheckbox,
		FormUpload,
		FormDate,
		FormTitle,
		FormSubTitle,
		FormBmi,
		FormSum,
		FormPathSelect,
		FormSbm,
		FormMsqV2,
		FormOcrPopup,
	},
	data: () => ({
		loading: true,
		showCodePopup: false,
		showOcrPopup: false,
		uploadFileList: [],
		detail: {
			relatedQuestionTypeDesc: "",
			relatedQuestionTypeName: "",
		},
		workTime: {
			submitTime: "",
			doneTime: "",
		},
		exam: [],

		isShowFailTopic: false,

		endTopicIndex: 999999999,
		isJump: "",
		jumpStartIndex: 0,
		jumpEndIndex: 0,
		currentIndex: "",
		isShow: false,
		indexValue: "",
		linkList: [],
		ocrList: [],
	}),
	computed: {
		saveUploadApi() {
			if (this.$route.query.isFollow) {
				return this.$api.surveys.followSubmitForm;
			}
			if (this.$route.query.formType === "edit") {
				return this.$api.surveys.asnwerUpdate;
			}
			return this.$api.surveys.submitAnswer;
		},
		baseFormId() {
			if (this.$route.query.formType) {
				return "";
			} else {
				return this.$route.params.id;
			}
		},
		allOcrKeywords() {
			let keywords = [];
			if (this.exam && Array.isArray(this.exam)) {
				this.exam.forEach((exam) => {
					if (exam.ocrKeywords && Array.isArray(exam.ocrKeywords)) {
						keywords = [...keywords, ...exam.ocrKeywords];
					}
				});
			}
			return keywords;
		},
	},
	mounted() {
		if (this.$route.query.isFollow) {
			this.getFollowDetail();
		} else if (this.$route.query.formType) {
			this.getAnswerDetail();
		} else {
			this.getDetail();
		}
	},
	watch: {},
	methods: {
		...mapMutations("surveys", ["SET_PAGE_TITLE"]),
		async getFollowDetail() {
			try {
				this.loading = true;
				const res = await this.$api.surveys.followDetail(
					this.$route.params.id
				);
				if (!res.code) {
					this.detail = res.data;
					if (this.$route.query.formType) {
						this.answerDetailFormat(
							res.data.answerJson,
							res.data.followDTO.followQuestionContent
						);
					} else {
						this.formDetailFormat(
							res.data.followDTO.followQuestionContent
						);
					}
					console.log("this.exam ===>", this.exam);
					this.SET_PAGE_TITLE(res.data.followDTO.followName);
				}
				this.loading = false;
			} catch (err) {
				console.log("表单解析失败===>", err);
				this.loading = false;
			}
		},

		async getDetail() {
			try {
				this.loading = true;
				const res = await this.$api.surveys.formDetail(
					this.$route.params.id
				);
				if (!res.code) {
					this.detail = res.data;
					this.formDetailFormat(res.data.formJson);
					console.log("this.exam ===>", this.exam);
					this.SET_PAGE_TITLE(res.data.title);
					if (this.detail.mainDeputyType == 3) {
						this.getLinkList();
					}
				}
				this.loading = false;
			} catch (err) {
				console.log("表单解析失败===>", err);
				this.loading = false;
			}
		},

		async getAnswerDetail() {
			try {
				this.loading = true;
				const res = await this.$api.surveys.asnwerDetail(
					this.$route.params.id
				);
				if (!res.code) {
					this.detail = res.data;
					if (!res.data.copyFormJson)
						return this.$toast("问卷列表初始化失败");
					this.answerDetailFormat(
						res.data.answerJson,
						res.data.copyFormJson
					);
					this.SET_PAGE_TITLE(res.data.surveyFormDTO.title);
					if (res.data.reviewStatus == 4) {
						this.getDoneTime(res.data);
					}
					if (this.detail.mainDeputyType == 3) {
						const baseFoemRes = await this.$api.surveys.formDetail(
							this.detail.formId
						);
						this.$set(
							this.detail,
							"relatedQuestionTypeDesc",
							baseFoemRes.data.relatedQuestionTypeDesc
						);
						this.$set(
							this.detail,
							"relatedQuestionTypeName",
							baseFoemRes.data.relatedQuestionTypeName
						);
					}
				}
				this.loading = false;
			} catch (err) {
				this.loading = false;
			}
		},
		getDoneTime(data) {
			this.$api.work
				.dmGetDoneTime(
					data.id,
					this.$route.query.isFollow
						? 13
						: this.$route.query.type == 1
						? 2
						: 3
				)
				.then((res) => {
					if (!res.code) {
						this.$set(
							this.workTime,
							"doneTime",
							res.data.slice(0, res.data.lastIndexOf(":"))
						);
						const submitTime =
							data.lastSubmitReviewTime ||
							data.firstSubmitReviewTime ||
							data.createTime;
						this.$set(
							this.workTime,
							"submitTime",
							submitTime.slice(0, submitTime.lastIndexOf(":"))
						);
					}
				});
			this.selectComponent("#workTimeEl").getDoneTime({
				id: res.data.zoneContentId,
				type: 10,
				submitTime: res.data.createTime,
			});
		},
		formDetailFormat(formJson) {
			const exam = JSON.parse(formJson);
			this.exam = exam.map((item) => ({
				...item,
				value: "12,31,32".includes(item.questionType) ? [] : "",
			}));
		},
		answerDetailFormat(answerJson, formJson) {
			const exam = JSON.parse(answerJson);
			const originExam = JSON.parse(formJson);
			const answerExamKeys = exam.map((item) => item.locationKey);

			try {
				this.exam = originExam.map((item, index) => {
					if (answerExamKeys.includes(item.locationKey)) {
						const topic = exam.find(
							(val) => val.locationKey == item.locationKey
						);
						if (
							topic.questionType == 31 ||
							topic.questionType == 32
						) {
							topic.value = (topic.value || []).filter(
								(val) => val.status == "done"
							);
						}
						if (topic.questionType == 11) {
							if (topic.value || topic.value === 0) {
								const questionJump =
									topic.optionList[topic.value].questionJump;
								if (
									questionJump &&
									questionJump.locationKey == -1
								) {
									this.endTopicIndex = index;
								}
							}
						}
						if (
							topic.questionType == 11 ||
							topic.questionType == 12
						) {
							topic.optionList.forEach((item) => {
								if (item.ext && item.ext.indexValue) {
									if (
										!item.ext.inputValue &&
										item.ext.type.includes("input")
									) {
										item.ext.inputValue =
											item.ext.indexValue || "";
									}
									if (
										!(item.ext.fileUrl || []).length &&
										item.ext.type.includes("img")
									) {
										item.ext.fileUrl =
											item.ext.indexValue || [];
									}
								}
							});
						}
						return topic;
					}
					return item;
				});
			} catch (err) {
				console.log(err);
			}

			console.log("this.exam ===>", this.exam);
			this.handleHideTopic();
		},
		getComponentName(val) {
			return (
				{
					11: "FormRadio",
					12: "FormCheckbox",
					22: "FormTextarea",
					31: "FormUpload",
					32: "FormUpload",
					41: "FormDate",
					61: "FormTitle",
					62: "FormSubTitle",
					101: "FormBmi",
					102: "FormSum",
					103: "FormMsqV2",
					110: "FormSbm",
					111: "FormPathSelect",
				}[val] || "FormInput"
			);
		},

		getComponentAttr(item, index, itemType) {
			const attrs = {
				label: `${item.name}`,
				index: index,
				itemKey: item.locationKey,
				layoutType: item.layoutType,
				placeholder: item.remark || `请输入内容`,
				endTopicIndex: this.endTopicIndex,
				isShowFailTopic: this.isShowFailTopic,
				auditStatus: this.detail.reviewStatus,
				rejectSetting: item.rejectSetting,
				exam: this.exam,
				item: item,
				minSelect: item.minSelect,
				maxSelect: item.maxSelect,
			};

			if ("11,12,21,101,102,103,110".includes(item.questionType)) {
				attrs["options"] = item.optionList;

				if ("21".includes(item.questionType)) {
					attrs["settingContent"] = item.settingContent || {};
					attrs["settingNumber"] = item.settingNumber || {};
					attrs["basicOperationFormula"] =
						item.basicOperationFormula || null;
					if (itemType == "sbm") {
						attrs.options.forEach((item) => {
							if (!item.settingContent) {
								item["settingContent"] = {
									contentRestrictions: 1,
									contentType: "letter",
									min: 1,
									max: 99999,
								};
							}
						});
					}
				}
			}
			if ("61,62".includes(item.questionType)) {
				attrs["fileInfo"] = {
					needFile: item.needFile,
					fileType: item.fileType,
					fileList: item.fileList,
				};
			}
			if ("11,12,41".includes(item.questionType)) {
				attrs["placeholder"] = item.remark || `请选择答案`;

				if ("41".includes(item.questionType)) {
					attrs["placeholder"] = item.remark || `请选择日期`;
					attrs["dateFormat"] = item.showDateFormat;
					attrs["timeSetting"] = item.timeSetting;
					attrs["timeLimitSetting"] = item.timeLimitSetting;
					attrs["timeDependSetting"] = item.timeDependSetting;
				}
				if ("12".includes(item.questionType)) {
					attrs["isManualSort"] = item.isManualSort;
				}
				if ("11,12".includes(item.questionType)) {
					attrs["fileType"] = item.fileType;
					attrs["fileList"] = item.fileList;
					attrs["optionType"] = item.optionType;
					attrs["options"].forEach((val) => {
						if (val.ext && typeof val.ext === "string") {
							val.ext = JSON.parse(val.ext);
						}
					});
				}
			}
			if ("22".includes(item.questionType)) {
				attrs["maxLength"] =
					typeof item.optionList[0].suffixName === "number"
						? item.optionList[0].suffixName
						: 1000;
			}
			if ("31,32".includes(item.questionType)) {
				attrs["placeholder"] = item.remark || `请上传图片`;
				attrs["limit"] = item.verifyMax;
				attrs["ocr"] = item.ocrText;
				attrs["accept"] =
					item.isImgOrVideo == 1
						? "*"
						: item.uploadImg && item.uploadVideo
						? "*"
						: item.uploadImg
						? "image/*"
						: "video/avi,video/mp4,video/mov,video/muv,video/AVI,video/MP4,video/MOV,video/MUV";
			}

			if (item.mustAnswer) {
				attrs["rules"] = [
					{ required: true, message: attrs.placeholder },
				];
			}

			return attrs;
		},

		// 特殊字段的特殊校验
		verification() {
			for (let i = 0; i < this.exam.length; i++) {
				const item = this.exam[i];
				// 图片题校验
				if (
					(item.questionType == 31 || item.questionType == 32) &&
					item.value
				) {
					const isExistUploading = item.value.some(
						(val) => val.status != "done"
					);
					if (isExistUploading) {
						this.$toast("请等待文件上传完成");
						return false;
					}
				}
			}
			return true;
		},
		verificationCheckout() {
			for (let i = 0; i < this.exam.length; i++) {
				const item = this.exam[i];
				// 多选题数量校验
				if (
					item.questionType == 12 &&
					item.minSelect &&
					item.maxSelect
				) {
					const selectedCount = item.value ? item.value.length : 0;
					if (
						selectedCount < item.minSelect ||
						selectedCount > item.maxSelect
					) {
						this.$toast(
							`"${item.name}"答案选项为${item.minSelect}-${item.maxSelect}个，当前选项不符合题目设置，请重新选择`
						);
						return false;
					}
				}
			}
			return true;
		},
		// 点击提交
		async clickSubmit(status) {
			this.handlerSumBlur();
			if (!this.verification()) return;
			if (status && !this.verificationCheckout()) return;
			try {
				let exam = this.exam;
				const answerJsonCopy = JSON.stringify(this.exam);
				if (
					this.endTopicIndex > -1 &&
					this.endTopicIndex <= this.exam.length &&
					status
				) {
					exam = this.exam.slice(0, this.endTopicIndex + 1);
				}
				if (status) {
					// 单独处理隐藏条件
					exam = exam.filter((item, index) =>
						this.checkShowMethods(item, index)
					);
				}
				let eGFR = exam.find(
					(item) => item.name === "估算肾小球滤过率 (eGFR)"
				);
				let Hb = exam.find((item) => item.name === "血红蛋白（Hb）");
				let riskLayer = exam.find(
					(item) => item.name === "该患者的Hb-ESRD风险分层"
				);
				if (riskLayer && eGFR && Hb) {
					let eGFRValue = eGFR.value;
					let HbValue = Hb.value;
					let riskLayerValue = riskLayer.value;
					// 根据Hb值换算因子
					let factor = 3.7;
					if (HbValue >= 80 && HbValue < 90) factor = 3.7;
					else if (HbValue >= 90 && HbValue < 100) factor = 3.1;
					else if (HbValue >= 100 && HbValue < 110) factor = 2.8;
					else if (HbValue >= 110 && HbValue < 120) factor = 2.6;
					else if (HbValue >= 120 && HbValue < 130) factor = 2.0;
					let number = (eGFRValue - 15) / factor;
					// 根据number值映射到0-4
					let riskCode = 0;
					if (number < 5) riskCode = 0;
					else if (number < 10) riskCode = 1;
					else if (number < 15) riskCode = 2;
					else if (number < 20) riskCode = 3;
					else riskCode = 4;
					console.log(riskCode, riskLayerValue);
					if (riskCode !== riskLayerValue) {
						Dialog.alert({
							title: "提示",
							message:
								"您选择的患者Hb-ESRD风险分层与登记信息不匹配，请复核后再提交",
							confirmButtonText: "知道了",
						}).then(() => {
							// on close
						});
						return;
					}
				}
				if (!(exam || []).length) {
					this.$toast(`网络繁忙，请刷新后重试`);
					return;
				}

				if (this.$route.query.isFollow) {
					await this.submitFollowForm(answerJsonCopy, exam, status);
					return;
				}
				this.checkIsDialogConfirm(
					this.$route.query.activityId,
					{ 1: "questionnaire", 2: "clinical" }[
						this.$route.query.type
					],
					() => this.submitHandle(answerJsonCopy, exam, status)
				);
			} catch (err) {
				this.loading = false;
			}
		},
		async submitHandle(answerJsonCopy, exam, status) {
			try {
				console.log("exam", exam, "answerJsonCopy", answerJsonCopy);
				const recognizeCode = this.getExamRecognizeCode(exam);
				const textContent = this.generateTextContent(exam);
				const attachmentUrl = this.generateAttachmentUrl(exam);
				let params = {
					answerJsonCopy,
					recognizeCode,
					answerJson: JSON.stringify(exam),
					surveyId: this.detail.surveyId,
					formId: this.detail.id,
					reviewStatus: status ? 1 : 0,
					budgetId:
						this.detail.budgetId || this.$route.query.budgetId,
					budgetSettingId:
						this.detail.budgetSettingId ||
						this.$route.query.budgetSettingId,
					taskId: this.$route.query.taskId,
					mainDeputyType: this.detail.mainDeputyType || 1,
					ocrList: this.ocrList.map((item) => ({
						imageUrl: item,
					})),
					textContent,
					attachmentUrl,
				};

				if (this.detail.mainDeputyType === 3) {
					params["mainAnswerId"] = this.detail.mainAnswerId;
					params["mainAnswerValue"] = this.detail.mainAnswerValue;
				}
				if (this.$route.query.formType === "edit") {
					params["id"] = this.$route.params.id;
					(params["formId"] = this.detail.formId),
						(params["taskId"] = this.detail.taskId);
				}
				if (this.loading) return;
				this.loading = true;
				const res = await this.saveUploadApi(params);
				this.loading = false;
				if (!res.code) {
					this.$router.replace({
						path: "/i-surveys/result",
						query: {
							status: status == 0 ? "draft" : "submit",
							type: this.$route.query.type,
							surveyId: this.detail.surveyId,
						},
					});
				}
			} catch (err) {
				this.loading = false;
			}
		},

		async submitFollowForm(answerJsonCopy, exam, reviewStatus) {
			try {
				const recognizeCode = this.getExamRecognizeCode(exam);
				const textContent = this.generateTextContent(exam);
				const attachmentUrl = this.generateAttachmentUrl(exam);
				const params = {
					answerJsonCopy,
					recognizeCode,
					answerId: this.detail.answerId,
					answerJson: JSON.stringify(exam),
					doctorId: this.detail.doctorId,
					followId: this.$route.params.followId,
					id: this.$route.params.id,
					reviewStatus: reviewStatus ? 1 : 4,
					ocrList: this.ocrList,
					textContent,
					attachmentUrl,
				};
				const res = await this.saveUploadApi(params);
				if (!res.code) {
					this.$router.go(-1);
				}
				this.loading = false;
			} catch (err) {
				console.log(err);
				this.loading = false;
			}
		},

		getExamRecognizeCode(l = []) {
			const t = l.find((v) => v.questionType == 110);
			return t
				? this.$refs[`topic_${t.locationKey}`][0].getExamRecognizeCode
				: "";
		},

		clickTemporaryStorage() {
			this.handlerSumBlur();

			this.clickSubmit(0);
		},

		generateTextContent(exam) {
			let result = "";
			let questionIndex = 1;
			exam.forEach((item) => {
				if (['61', '62'].includes(item.questionType)) {
					result += `\n${item.name}\n`;
				} else {
					result += ` 问题：${questionIndex}. ${item.name}\n`;
					if (item.optionList && item.optionList.length) {
						const optionsText = item.optionList
							.map((opt) => opt.name)
							.join("、");
						result += ` 选项：${optionsText}\n`;
					}
					let answerText = item.value;
					if (['31', '32'].includes(item.questionType)) {
						if (Array.isArray(item.value)) {
							answerText = item.value
								.map((file) => file.url || file)
								.join("，");
						}
					}
					result += ` 答案：${answerText || ""}\n`;
					questionIndex++;
				}
			});
			return result.trim();
		},
		generateAttachmentUrl(exam) {
			const attachments = [];
			exam.forEach((item) => {
				if (['31', '32'].includes(item.questionType) && item.value) {
					if (Array.isArray(item.value)) {
						item.value.forEach((file) => {
							if (file.url) {
								attachments.push(file.url);
							} else if (typeof file === "string") {
								attachments.push(file);
							}
						});
					} else if (typeof item.value === "string") {
						attachments.push(item.value);
					}
				}
			});
			return attachments.join(",");
		},
		exitIntercept() {
			if (this.$route.query.formType === "preview") {
				this.$router.go(-1);
				return;
			}
			const _this = this;
			this.$dialog
				.confirm({
					title: "提示",
					message: "确认退出调研？",
					confirmButtonText: "取 消",
					cancelButtonText: "确认并保存",
				})
				.then(() => {
					_this.$router.go(-1);
				})
				.catch(() => {
					_this.clickSubmit(0);
				});
		},

		handleHideTopicCallback(currentIndex, targetIndex) {
			this.exam.forEach((item, index) => {
				if (currentIndex > targetIndex) {
					if (index > targetIndex) {
						item.hideTopic = index < currentIndex;
					}
				}
				if (currentIndex < targetIndex) {
					if (index > currentIndex) {
						item.hideTopic = index < targetIndex;
					}
				}
			});
		},

		handleHideTopic() {
			this.exam.forEach((item) => {
				item.hideTopic = false;
			});

			this.exam.forEach((item, index) => {
				if (item.value || item.value === 0) {
					if (item.questionType == 11) {
						const questionJump =
							item.optionList[item.value].questionJump;
						if (questionJump) {
							const targetIndex = this.exam.findIndex(
								(val) =>
									questionJump.locationKey == val.locationKey
							);
							targetIndex > -1 &&
								this.handleHideTopicCallback(
									index,
									targetIndex
								);
						}
					}
				}
			});
		},

		handleScrollExam({ questionJump }, index) {
			if (index === this.endTopicIndex) {
				if (!questionJump || questionJump.locationKey != -1) {
					this.endTopicIndex = 999999999;
				}
			}

			if (questionJump) {
				if (questionJump.locationKey == -1) {
					this.endTopicIndex = index;
				}
			}

			this.handleHideTopic();
		},

		updateOptions(list, examIndex) {
			this.$set(this.exam[examIndex], "optionList", list);
		},

		checkShowMethods(item, index, isClearValue) {
			if (item.hideTopic) return false;

			if (!item.settingShow) return true;
			if (!(item.settingShow || []).length) return true;

			const locationKeyArr = item.settingShow.map(
				(val) => val.locationKey
			);
			const trainTopicArr = this.exam.filter((val) =>
				locationKeyArr.includes(val.locationKey)
			);
			for (let i = 0; i < trainTopicArr.length; i++) {
				const topic = trainTopicArr[i];
				const targetTopic = item.settingShow.find(
					(val) => val.locationKey == topic.locationKey
				);
				if (targetTopic) {
					if (
						topic.questionType == 11 &&
						(topic.value || topic.value === 0)
					) {
						const locationKey = topic.optionList[topic.value].key;
						if (targetTopic.optionId.includes(locationKey))
							return true;
					} else if (
						topic.questionType == 12 &&
						(topic.value || []).length
					) {
						for (let j = 0; j < topic.value.length; j++) {
							const locationKey =
								topic.optionList[topic.value[j]].key;
							if (targetTopic.optionId.includes(locationKey))
								return true;
						}
					}
				}
			}

			if (isClearValue) {
				if (
					Object.prototype.toString.call(item.value) ===
					"[object Array]"
				) {
					if (item.value.length) {
						item.value = [];
					}
				} else if (item.value || item.value === 0) {
					item.value = "";
				}
			}
			return false;
		},
		isNotEmpty(value) {
			if (value === null) return false;
			if (value === undefined) return false;
			if (Array.isArray(value) && value.length === 0) {
				return false;
			} else if (typeof value === "string" && value === "") {
				return false;
			}
			return true;
		},
		handlerSumBlur() {
			if (
				this.exam.findIndex((item) => item.questionType == "102") != -1
			) {
				let sumList = this.exam.filter(
					(item) => item.questionType == "102"
				);
				sumList.forEach((item) => {
					let sum = 0;
					let validSum = 0;
					let validCount = 0;
					let startIndex = this.exam.findIndex(
						(item1) => item1.locationKey == item.startKey
					);
					let endIndex = this.exam.findIndex(
						(item1) => item1.locationKey == item.endKey
					);

					for (let i = startIndex; i <= endIndex; i++) {
						if (!item.chooseQuestionType) {
							const value = this.exam[i].value || "";
							const countResult =
								this.validatorCommentCountWithValidCheck(
									value,
									this.exam[i]
								);
							sum += countResult.totalCount;
							validSum += countResult.validCount;
							validCount += countResult.isValid ? 1 : 0;
						} else {
							const chooseQuestionType =
								item.chooseQuestionType.join(",");
							if (
								!chooseQuestionType.includes(
									this.exam[i].questionType
								)
							)
								continue;
							const countResult =
								this.validatorCountWithValidCheck(this.exam[i]);
							sum += countResult.totalCount;
							validSum += countResult.validCount;
							validCount += countResult.isValid ? 1 : 0;
						}
					}

					const average =
						validCount > 0 ? (validSum / validCount).toFixed(2) : 0;

					item.value = `${sum}@%_@%${average}`;
				});
			}
		},

		handleCalculateFormula(changedItemKey) {
			const formulaItems = this.exam.filter(
				(item) =>
					item.questionType === "21" &&
					item.basicOperationFormula &&
					Array.isArray(item.basicOperationFormula)
			);

			formulaItems.forEach((item) => {
				const containsChangedItem = item.basicOperationFormula.some(
					(formulaItem) =>
						formulaItem.type === "question" &&
						formulaItem.id === changedItemKey
				);

				if (containsChangedItem) {
					const result = this.calculateFormulaResult(
						item.basicOperationFormula
					);
					if (result !== null) {
						this.$set(item, "value", result.toString());
					}
				}
			});
		},

		calculateFormulaResult(formula) {
			try {
				let expression = "";

				for (let i = 0; i < formula.length; i++) {
					const item = formula[i];

					if (item.type === "question") {
						const question = this.exam.find(
							(examItem) => examItem.locationKey === item.id
						);
						if (question && question.value) {
							const value = question.value.split("@%_@%")[0];
							const numValue = parseFloat(value);
							expression += isNaN(numValue) ? 0 : numValue;
						} else {
							expression += "0";
						}
					} else if (item.type === "operator") {
						expression += item.text;
					} else if (item.type === "number") {
						expression += item.text;
					}
				}

				const result = new Function("return " + expression)();
				if (isNaN(result)) return null;

				return this.fixFloatingPoint(result);
			} catch (error) {
				console.error("公式计算错误:", error);
				return null;
			}
		},

		fixFloatingPoint(num) {
			if (typeof num !== "number") return num;

			return Math.round(num * 10) / 10;
		},

		validatorCommentCount(value) {
			let counts = value.split("@%_@%");
			return counts.reduce((acc, currentValue) => {
				let number = Number(currentValue);
				return acc + (isNaN(number) ? 0 : number);
			}, 0);
		},
		validatorCount(topic) {
			let value = topic.value;
			if (!this.isNotEmpty(value)) return 0;
			if (topic.questionType == 11) {
				value = topic.optionList[value].name;
			}
			if (topic.questionType == 12) {
				value = value
					.map((item) => topic.optionList[item].name)
					.join("@%_@%");
			}
			if (!value) return 0;
			let counts = value.split("@%_@%");
			return counts.reduce((acc, currentValue) => {
				let number = Number(currentValue);
				return acc + (isNaN(number) ? 0 : number);
			}, 0);
		},
		getSbm(options) {
			let [a, b, c] = ["", "", ""];
			options.forEach((v) => {
				if (v.questionType == 21) {
					a = (v.value || "").toUpperCase();
				}

				if (v.questionType == 11) {
					if (v.value === 0) b = "M";
					if (v.value === 1) b = "F";
				}
				if (v.questionType == 41) {
					c = (v.value || "").split("-").join("");
				}
			});
			return a + b + c;
		},
		getLinkList() {
			this.$api.surveys
				.getRecognizeCodes({ surveyFormId: this.baseFormId })
				.then((res) => {
					if (!res.code) {
						this.linkList = res.data.map((item) => {
							let answerJson = JSON.parse(item.answerJson);
							let code = answerJson.find(
								(val) =>
									val.locationKey ==
									this.detail.relatedQuestionType
							);
							console.log(answerJson, code);
							let text = code.value;
							if (code.questionType == "110") {
								text = this.getSbm(code.optionList);
							}
							if (code.questionType == "11") {
								text = code.optionList[code.value].name;
							}
							return {
								text: text,
								id: item.id,
							};
						});
					}
				});
		},
		showPicker() {
			if (["preview", "edit"].indexOf(this.$route.query.formType) > -1) {
				return;
			}
			if (this.linkList.length == 0) {
				this.$toast("无已提交的识别码");
				return;
			}
			this.showCodePopup = true;
		},
		linkConfirm(value) {
			this.detail.mainAnswerId = value.id;
			this.detail.mainAnswerValue = value.text;
			this.showCodePopup = false;
		},
		linkCancel() {
			this.showCodePopup = false;
		},

		isInvalidOption(optionName) {
			const invalidOptions = ["没法比较", "不知道"];
			return invalidOptions.some((invalid) =>
				optionName.includes(invalid)
			);
		},

		validatorCommentCountWithValidCheck(value, topic) {
			let totalCount = 0;
			let validCount = 0;
			let isValid = true;

			let counts = value.split("@%_@%");
			counts.forEach((currentValue) => {
				let number = Number(currentValue);
				totalCount += isNaN(number) ? 0 : number;

				if (this.isInvalidOption(currentValue)) {
					isValid = false;
				} else {
					validCount += isNaN(number) ? 0 : number;
				}
			});

			return { totalCount, validCount, isValid };
		},

		validatorCountWithValidCheck(topic) {
			let totalCount = 0;
			let validCount = 0;
			let isValid = true;

			let value = topic.value;
			if (!this.isNotEmpty(value))
				return { totalCount: 0, validCount: 0, isValid: false };

			if (topic.questionType == 11) {
				value = topic.optionList[value].name;

				if (this.isInvalidOption(value)) {
					isValid = false;
				}
			}

			if (topic.questionType == 12) {
				let hasInvalidOption = false;
				let validValues = [];
				value.forEach((item) => {
					const optionName = topic.optionList[item].name;
					if (this.isInvalidOption(optionName)) {
						hasInvalidOption = true;
					} else {
						validValues.push(optionName);
					}
				});
				value = validValues.join("@%_@%");
				if (hasInvalidOption && validValues.length === 0) {
					isValid = false;
				}
			}

			if (!value) return { totalCount: 0, validCount: 0, isValid: false };

			let counts = value.split("@%_@%");
			counts.forEach((currentValue) => {
				let number = Number(currentValue);
				totalCount += isNaN(number) ? 0 : number;
				validCount += isNaN(number) ? 0 : number;
			});

			return { totalCount, validCount, isValid };
		},

		async handleOcrSuccess(ocrData, ocrImageUrls) {
			this.showOcrPopup = false;
			try {
				if (ocrImageUrls && Array.isArray(ocrImageUrls)) {
					this.ocrList = ocrImageUrls;
				}

				if (ocrData && typeof ocrData === "object") {
					for (const [keyword, value] of Object.entries(ocrData)) {
						if (value !== null) {
							const formItem = this.exam.find((item) => {
								return (
									item.ocrKeywords &&
									Array.isArray(item.ocrKeywords) &&
									item.ocrKeywords.includes(keyword)
								);
							});

							if (formItem) {
								switch (formItem.questionType) {
									case "21":
									case "102":
									case "103":
										const validationResult =
											this.validateOcrInputValue(
												value,
												formItem
											);
										if (validationResult.isValid) {
											this.$set(
												formItem,
												"value",
												validationResult.value
											);
										}
										break;
									case "22":
										this.$set(formItem, "value", value);
										break;
									case "11":
										const radioOptionIndex =
											formItem.optionList.findIndex(
												(opt) =>
													opt.name.includes(value)
											);
										if (radioOptionIndex !== -1) {
											this.$set(
												formItem,
												"value",
												radioOptionIndex
											);
										} else {
											const selectedOption =
												formItem.optionList[0];
											if (
												selectedOption &&
												selectedOption.ext &&
												selectedOption.ext.type &&
												selectedOption.ext.type.includes(
													"input"
												)
											) {
												const validationResult =
													this.validateOcrInputValue(
														value,
														selectedOption
													);
												if (validationResult.isValid) {
													this.$set(
														formItem,
														"value",
														0
													);
													this.$set(
														selectedOption.ext,
														"inputValue",
														validationResult.value
													);
												}
											} else {
												this.$set(
													formItem,
													"value",
													value
												);
											}
										}
										break;
									case "12":
										const checkboxOptionIndex =
											formItem.optionList.findIndex(
												(opt) =>
													opt.name.includes(value)
											);
										if (checkboxOptionIndex !== -1) {
											const currentValue =
												formItem.value || [];
											if (
												!currentValue.includes(
													checkboxOptionIndex
												)
											) {
												this.$set(formItem, "value", [
													...currentValue,
													checkboxOptionIndex,
												]);
											}
										} else {
											const selectedOption =
												formItem.optionList[0];
											if (
												selectedOption &&
												selectedOption.ext &&
												selectedOption.ext.type &&
												selectedOption.ext.type.includes(
													"input"
												)
											) {
												const validationResult =
													this.validateOcrInputValue(
														value,
														selectedOption
													);
												if (validationResult.isValid) {
													const currentValue =
														formItem.value || [];
													if (
														!currentValue.includes(
															0
														)
													) {
														this.$set(
															formItem,
															"value",
															[...currentValue, 0]
														);
														this.$set(
															selectedOption.ext,
															"inputValue",
															validationResult.value
														);
													}
												}
											}
										}
										break;
									default:
										this.$set(formItem, "value", value);
										break;
								}
							}
						}
					}
					this.$toast("识别完成");
				}
			} catch (error) {
				console.error("OCR识别成功处理失败:", error);
				this.$toast("识别结果处理失败，请重试");
			}
		},

		validateOcrInputValue(value, option) {
			if (!value && value !== 0) return { isValid: true, value: value };

			let settingContent = null;

			if (option.settingContent) {
				settingContent = option.settingContent;
			} else if (option.ext && option.ext.settingContent) {
				settingContent = option.ext.settingContent;
			} else if (
				option.optionList &&
				option.optionList[0] &&
				option.optionList[0].settingContent
			) {
				settingContent = option.optionList[0].settingContent;
			}

			const contentType = settingContent?.contentType;

			if (settingContent && settingContent.contentRestrictions) {
				switch (contentType) {
					case "number":
						return this.extractAndValidateNumber(
							value,
							settingContent
						);
					case "letter":
						return this.extractAndValidateLetter(value);
					case "character":
						return this.extractAndValidateCharacter(value);
				}
			}

			return this.extractAndValidateValueLength(
				value,
				option,
				settingContent
			);
		},

		extractAndValidateNumber(value, settingContent) {
			if (value === "-") return { isValid: true, value: value };

			let extractedValue = value;

			const numberMatch = value.match(/-?\d+(\.\d+)?/);
			if (numberMatch) {
				extractedValue = numberMatch[0];
			} else {
				return { isValid: false, value: "" };
			}

			const numValue = parseFloat(extractedValue);

			if (settingContent) {
				if (
					typeof settingContent.numberMin === "number" &&
					numValue < settingContent.numberMin
				) {
					return { isValid: false, value: "" };
				}
				if (
					typeof settingContent.numberMax === "number" &&
					numValue > settingContent.numberMax
				) {
					return { isValid: false, value: "" };
				}
			}

			return { isValid: true, value: extractedValue };
		},

		extractAndValidateLetter(value) {
			if (!value && value !== 0) return { isValid: true, value: value };

			let extractedValue = value;

			const letterMatch = value.match(/[A-Za-z\s]+/);
			if (letterMatch) {
				extractedValue = letterMatch[0];
			} else {
				return { isValid: false, value: "" };
			}

			return { isValid: true, value: extractedValue };
		},

		extractAndValidateCharacter(value) {
			if (!value && value !== 0) return { isValid: true, value: value };

			let extractedValue = value;

			const charMatch = value.match(/[\u4e00-\u9fa5]+/);
			if (charMatch) {
				extractedValue = charMatch[0];
			} else {
				return { isValid: false, value: "" };
			}

			return { isValid: true, value: extractedValue };
		},

		extractAndValidateValueLength(value, option, settingContent) {
			let extractedValue = value;
			let isValid = true;

			if (settingContent) {
				if (
					typeof settingContent.min === "number" &&
					value.length < settingContent.min
				) {
					isValid = false;
				}
				if (
					typeof settingContent.max === "number" &&
					value.length > settingContent.max
				) {
					extractedValue = value.substring(0, settingContent.max);
				}
			}

			if (option.ext && option.ext.settingContent) {
				const optionSettingContent = option.ext.settingContent;
				if (
					typeof optionSettingContent.min === "number" &&
					value.length < optionSettingContent.min
				) {
					isValid = false;
				}
				if (
					typeof optionSettingContent.max === "number" &&
					value.length > optionSettingContent.max
				) {
					extractedValue = value.substring(
						0,
						optionSettingContent.max
					);
				}
			}

			return { isValid, value: extractedValue };
		},
	},
};
</script>

<style scoped>
.placeholder {
	height: 20px;
}

.work_time {
	font-size: 14px;
	color: gray;
	padding: 10px 0;
	border-bottom: 1px solid #ddd;
}

.ocr-button-fixed {
	position: absolute;
	top: 12px;
	right: 12px;
	z-index: 999;
}
</style>
